import React from "react";
import {Col, Form, Row} from "react-bootstrap";
import {Select} from "../../../genericComponents";
import {useFormFull} from "form-full";
import CboAutoComplete from "../../InputAutoComplete/CboAutoComplete";

function CboField({ disabled }) {
  // A busca no CBO continua em tela, mas gravamos apenas a descrição (texto livre)
  // diretamente no campo "occupation" — sem vínculo com o código do CBO.
  const { value: occupation, onChange: onChangeOccupation, formDisabled } =
    useFormFull.field({ name: "occupation" });

  return (
    <Form.Group as={Col} xs={12} md={6}>
      <Form.Label>Profissão</Form.Label>
      <CboAutoComplete
        value={occupation ?? null}
        disabled={disabled || formDisabled}
        onChange={(descricao) => onChangeOccupation(null, descricao)}
      />
    </Form.Group>
  );
}

function BasicData6({ disabled }) {
  return (
    <Row>
      <CboField disabled={disabled} />

      <Select
        colProps={{ xs: 12, md: 6 }}
        label="Estado Civil"
        name="maritalStatus"
        required='O valor do campo "Estado Civil" deve ser selecionado.'
        disabled={disabled}
        placeholder="Selecione um estado civil"
        options={[
          "Solteiro(a)",
          "Casado(a)",
          "Separado(a)",
          "Divorciado(a)",
          "Viúvo(a)",
          "União Estável",
        ].map((item) => ({ label: item, value: item }))}
      />
    </Row>
  );
}

export default BasicData6;
